import { render, staticRenderFns } from "./CountryInformation.vue?vue&type=template&id=426495f8&"
import script from "./CountryInformation.vue?vue&type=script&lang=js&"
export * from "./CountryInformation.vue?vue&type=script&lang=js&"
import style0 from "./CountryInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports